var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMulher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_547",
    "data-name": "Grupo 547",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_151",
    "data-name": "Elipse 151",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    fill: "rgb(132, 170, 255)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-woman",
    "data-name": "Icon ionic-ios-woman",
    transform: "translate(24.742 12.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2275",
    "data-name": "Caminho 2275",
    d: "M26.417,50.142a2.438,2.438,0,0,1-1.763-.727,2.827,2.827,0,0,1-.782-2.049V34.211H22.341V47.365a2.77,2.77,0,0,1-.815,2.06,2.61,2.61,0,0,1-3.592,0,2.75,2.75,0,0,1-.815-2.06V34.211H12.282l4.9-18.8h-.749l-2.688,9.96a2.5,2.5,0,0,1-2.358,1.961h0a2.344,2.344,0,0,1-1.873-.959,2.972,2.972,0,0,1-.4-2.633l3.2-11.469a6.023,6.023,0,0,1,5.365-4.33H28.521c3.129.132,4.859,2.865,5.343,4.286l.011.044,3.2,11.491a3,3,0,0,1-.43,2.644,2.359,2.359,0,0,1-1.862.947,2.5,2.5,0,0,1-2.347-1.994v-.022l-2.677-9.927h-.848l5.013,18.8H28.951V47.365a2.827,2.827,0,0,1-.782,2.049A2.413,2.413,0,0,1,26.417,50.142Z",
    transform: "translate(-8.983 2.741)",
    fill: "#343131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2276",
    "data-name": "Caminho 2276",
    d: "M19.743,11.085A4.917,4.917,0,0,1,14.906,6.1a4.839,4.839,0,1,1,9.673,0A4.917,4.917,0,0,1,19.743,11.085Z",
    transform: "translate(-5.625 -1.125)",
    fill: "#343131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulher);
export default __webpack_public_path__ + "static/media/mulher.3a0c72860bf9b62849947f356a239876.svg";
export { ForwardRef as ReactComponent };